<template>
    <div class="page">
        <!-- 顶部背景 -->
        <div class="top-header">
            <div class="header-bg"></div>
            <div class="header-content">
                <div class="header-icon-wrap">
                    <img src="@/assets/img/she/shebei.png" alt="" class="header-icon">
                </div>
                <div class="header-text">
                    <div class="header-title">实名认证</div>
                    <div class="header-desc">完成实名认证后即可正常使用设备</div>
                </div>
            </div>
        </div>

        <!-- 认证卡片列表 -->
        <div class="auth-cards">
            <div class="auth-card" @click="toAllAuth(dataForm.sysMap.inIccid1)"
                v-if="dataForm.sysMap && dataForm.sysMap.inIccid1 && dataForm.sysMap.inIccid1.length > 2">
                <div class="card-left">
                    <div class="card-icon-wrap card-icon-dx">
                        <img src="@/assets/img/she/icon_zgdx.png" alt="" class="card-icon">
                    </div>
                    <div class="card-info">
                        <div class="card-name">电信实名</div>
                    </div>
                </div>
                <div class="card-right">
                    <span class="auth-tag" :class="in1AuthName === '已实名' ? 'auth-done' : 'auth-pending'">{{ in1AuthName }}</span>
                    <van-icon name="arrow" color="#bbb" size="16" />
                </div>
            </div>

            <div class="auth-card" @click="toAllAuth(dataForm.sysMap.inIccid2)"
                v-if="dataForm.sysMap && dataForm.sysMap.inIccid2 && dataForm.sysMap.inIccid2.length > 2">
                <div class="card-left">
                    <div class="card-icon-wrap card-icon-lt">
                        <img src="@/assets/img/she/icon_zglt.png" alt="" class="card-icon">
                    </div>
                    <div class="card-info">
                        <div class="card-name">联通实名</div>
                    </div>
                </div>
                <div class="card-right">
                    <span class="auth-tag" :class="in2AuthName === '已实名' ? 'auth-done' : 'auth-pending'">{{ in2AuthName }}</span>
                    <van-icon name="arrow" color="#bbb" size="16" />
                </div>
            </div>

            <div class="auth-card" @click="toAllAuth(dataForm.sysMap.outIccid)"
                v-if="dataForm.sysMap && dataForm.sysMap.outIccid && dataForm.sysMap.outIccid.length > 2">
                <div class="card-left">
                    <div class="card-icon-wrap card-icon-yd">
                        <img src="@/assets/img/she/icon_zgyd.png" alt="" class="card-icon">
                    </div>
                    <div class="card-info">
                        <div class="card-name">移动实名</div>
                    </div>
                </div>
                <div class="card-right">
                    <span class="auth-tag" :class="outAuthName === '已实名' ? 'auth-done' : 'auth-pending'">{{ outAuthName }}</span>
                    <van-icon name="arrow" color="#bbb" size="16" />
                </div>
            </div>

            <!-- 无数据提示 -->
            <div class="empty-tip" v-if="!dataForm.sysMap || (!dataForm.sysMap.inIccid1 && !dataForm.sysMap.inIccid2 && !dataForm.sysMap.outIccid)">
                <van-icon name="info-o" size="40" color="#ddd" />
                <div class="empty-text">暂无需要实名的卡</div>
            </div>
        </div>

        <!-- 温馨提示 -->
        <div class="tips-section">
            <div class="tips-title">
                <van-icon name="warning-o" size="15" color="#4A90D9" />
                <span>温馨提示</span>
            </div>
            <div class="tips-list">
                <div class="tips-item">
                    <span class="tips-dot"></span>
                    <span>实名后方可正常使用设备</span>
                </div>
                <div class="tips-item">
                    <span class="tips-dot"></span>
                    <span>任何不懂可联系我们在线客服</span>
                </div>
            </div>
        </div>

        <van-dialog v-model="show" title="温馨提示" @confirm="confirm" @cancel="cancel" show-cancel-button
            confirmButtonText="确定切换" cancelButtonText="取消切换" confirmButtonColor="#333" cancelButtonColor="#9e9e9e">
            <div class="el-tip">
                <div>1.切换成功前，请先在设备内网进行切换</div>
                <div>2.切换成功之后，系统将会自动退出 需要重新登录。</div>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import { wxRequest } from "@/api/user";
import { Dialog,Toast  } from "vant";
export default {
    data() {
        return {
            outAuthName: '',
            in1AuthName: '',
            in2AuthName: '',
            recordLoginText: localStorage.getItem("recordLoginText"),
            dataForm: {},
            show: false,
            wxHeadImg: localStorage.getItem("wxHeadImg"),
            radio: '',
            radioCopy: "",
            battery: '',
            iccid: localStorage.getItem("iccid"),
            // iccid: '8986062339002267697',
        }
    },
    created() {
        this.init()
    },
    watch: {
        radio(val, old) {
            this.radioCopy = old
        }
    },
    methods: {
        toAllAuth(iccid) { 
            wxRequest("sim/detail", { iccid: iccid ,shebeiAuth:'yes'}, "post").then((res) => {
                if (res.data.code === '200') {
                    var flowRatePool = res.data.data.flowRatePool;
                    if (flowRatePool == "移动接口") {
                        wxRequest(
                            "wxAuth/cmcc/auth",
                            { iccid: iccid, isCheckout: "1s" },
                            "post"
                        ).then((res) => {
                            if (res.data.code == "200") {
                                window.location.href = res.data.data;
                            } else {
                                Dialog.alert({
                                    title: "提示",
                                    message: res.data.message,
                                });
                            }
                        });
                    } else if (flowRatePool == '移动') {
                        window.location.href = 'http://czlj.wzyw.cc/#/user/cmccAuthUrl?iccid=' + iccid + "&intoNo=" +res.data.data.intoNo;
                    } else if (flowRatePool == '联通') {
                        window.location.href = 'http://czlj.wzyw.cc/#/user/cuccAuthUrl?iccid=' + iccid
                    } else if (flowRatePool == '5G电信' || flowRatePool == '电信') {
                        wxRequest(
                            "wxAuth/ctcc/to/5G/auth",
                            { iccid: iccid, isCheckout: "sa" },
                            "post"
                        ).then((res) => {
                            if (res.data.code == "200") {
                                window.location.href = res.data.data;
                            } else {
                                Dialog.alert({
                                    title: "提示",
                                    message: res.data.message,
                                });
                            }
                        });
                    } else {
                        if (flowRatePool.indexOf("?") >= 0) {
                            window.location.href = flowRatePool + "&cn=" + iccid + "&iccid=" + iccid + "&cardno=" + iccid
                                + "&card_number=" + +localStorage.getItem('virtualNo');
                        } else {
                            window.location.href = flowRatePool + "?cn=" + iccid + "&iccid=" + localStorage.getItem('virtualNo') + "&cardno=" + iccid
                                + "&card_number=" + +localStorage.getItem('virtualNo');
                        }
                    }
                } else {
                    Toast.fail(res.data.message);
                }
            })
        },


       
        toHome() {
            if (localStorage.getItem('isNewPage') == 0) {
                this.$router.replace('/user/home');
            } else if (localStorage.getItem('isNewPage') == 1) {
                this.$router.replace('/userNew/home');
            } else if (localStorage.getItem('isNewPage') == 2) {
                this.$router.replace('/user/homeNew');
            } else if (localStorage.getItem('isNewPage') == 3) {
                this.$router.replace('/new/home');
            } else {
                this.$router.replace('/user/home');
            }
        },
      
        init() {
            var data = {
                iccid: this.iccid
            }
            wxRequest("sim/get/shebei/info/base", data, "post").then(res => {
                if (res.data.code === '200') {
                    this.dataForm = res.data.data
                    this.radio = String(res.data.data.netState)
                    this.outAuthName = res.data.data.sysMap.outAuthName;
                    this.in1AuthName = res.data.data.sysMap.in1AuthName;
                    this.in2AuthName = res.data.data.sysMap.in2AuthName;
                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    })
                }
            })
        },
        radioChange(e) {
            this.radio = e
            this.show = true
        },
        cancel() {
            this.radio = this.radioCopy
            this.show = false
        },
        confirm() {
            if (this.radio == 1 && this.in1AuthName == '未实名') {
                Dialog.alert({
                    title: '实名提示',
                    message: '请先完成实名后再来进行切换操作，如已实名 请耐心等待5-10分钟完成实名同步'
                })
                return;
            }
            if (this.radio == 2 && this.in2AuthName == '未实名') {
                Dialog.alert({
                    title: '实名提示',
                    message: '请先完成实名后再来进行切换操作，如已实名 请耐心等待5-10分钟完成实名同步'
                })
                return;
            }
            if (this.radio == 0 && this.outAuthName == '未实名') {
                Dialog.alert({
                    title: '实名提示',
                    message: '请先完成实名后再来进行切换操作，如已实名 请耐心等待5-10分钟完成实名同步'
                })
                return;
            }
            var data = {
                iccid: this.iccid
            }
            if (this.radio == 1) {
                data.cardSlot = this.dataForm.sysMap.in1Num
                data.newIccid = this.dataForm.sysMap.inIccid1
            } else if (this.radio == 2) {
                data.cardSlot = this.dataForm.sysMap.in2Num
                data.newIccid = this.dataForm.sysMap.inIccid2
            } else if (this.radio == 0) {
                data.cardSlot = this.dataForm.sysMap.outNum
                data.newIccid = this.dataForm.sysMap.outIccid
            }
            wxRequest("sim/update/shebei/qie/base", data, "post").then(res => {
                if (res.data.code === '200') {
                    Dialog.alert({
                        title: '切换成功',
                        message: res.data.message
                    })
                    localStorage.setItem("iccid", data.newIccid);
                    this.$store.state.iccid = data.newIccid;
                    //window.location.href = 'http://cz.dierun.cn/#/userNew/login';
                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    })
                }
            })
        },
        backPage() {
            let _this = this;
            if (_this.$store.state.isNewPage == 1 || localStorage.getItem('isNewPage') == 1) {
                _this.$router
                    .push({
                        path: "/userNew/home",
                        query: {
                            iccid: _this.$store.state.iccid,
                        },
                    })
                    .catch(() => { });
            } else {
                _this.$router
                    .push({
                        path: "/user/home",
                        query: {
                            iccid: _this.$store.state.iccid,
                        },
                    })
                    .catch(() => { });
            }
        }
    }
}
</script>

<style lang="less" scoped>
.page {
    min-height: 100vh;
    background: #F5F6F7;

    // 顶部背景区域
    .top-header {
        position: relative;
        height: 180px;
        overflow: hidden;

        .header-bg {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(135deg, #4A90D9 0%, #3B7DD8 50%, #2B66C5 100%);
            border-radius: 0 0 24px 24px;
        }

        .header-content {
            position: relative;
            z-index: 1;
            display: flex;
            align-items: center;
            padding: 50px 24px 0;

            .header-icon-wrap {
                width: 56px;
                height: 56px;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                backdrop-filter: blur(4px);
                margin-right: 16px;
                flex-shrink: 0;

                .header-icon {
                    width: 36px;
                    height: 36px;
                }
            }

            .header-text {
                color: #fff;

                .header-title {
                    font-size: 22px;
                    font-weight: 700;
                    margin-bottom: 6px;
                    letter-spacing: 1px;
                }

                .header-desc {
                    font-size: 13px;
                    opacity: 0.85;
                    font-weight: 400;
                }
            }
        }
    }

    // 认证卡片列表
    .auth-cards {
        margin: -30px 16px 0;
        position: relative;
        z-index: 2;

        .auth-card {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #fff;
            border-radius: 14px;
            padding: 16px;
            margin-bottom: 12px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
            transition: transform 0.2s ease, box-shadow 0.2s ease;

            &:active {
                transform: scale(0.98);
                box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
            }

            .card-left {
                display: flex;
                align-items: center;
                flex: 1;
                min-width: 0;

                .card-icon-wrap {
                    width: 44px;
                    height: 44px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 14px;
                    flex-shrink: 0;

                    .card-icon {
                        width: 28px;
                        height: 28px;
                    }
                }

                .card-icon-dx {
                    background: linear-gradient(135deg, #E8F4FD, #D1ECFF);
                }

                .card-icon-lt {
                    background: linear-gradient(135deg, #FFE8E8, #FFD6D6);
                }

                .card-icon-yd {
                    background: linear-gradient(135deg, #E8F9E8, #D1F5D1);
                }

                .card-info {
                    min-width: 0;

                    .card-name {
                        font-size: 16px;
                        font-weight: 600;
                        color: #333;
                        margin-bottom: 4px;
                    }

                    .card-iccid {
                        font-size: 12px;
                        color: #999;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 180px;
                    }
                }
            }

            .card-right {
                display: flex;
                align-items: center;
                flex-shrink: 0;
                margin-left: 12px;

                .auth-tag {
                    font-size: 12px;
                    padding: 3px 10px;
                    border-radius: 20px;
                    margin-right: 6px;
                    white-space: nowrap;
                }

                .auth-done {
                    color: #52C41A;
                    background: #F6FFED;
                    border: 1px solid #B7EB8F;
                }

                .auth-pending {
                    color: #FF4D4F;
                    background: #FFF2F0;
                    border: 1px solid #FFCCC7;
                }
            }
        }

        .empty-tip {
            background: #fff;
            border-radius: 14px;
            padding: 40px 16px;
            text-align: center;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

            .empty-text {
                color: #999;
                font-size: 14px;
                margin-top: 12px;
            }
        }
    }

    // 温馨提示
    .tips-section {
        margin: 20px 16px 30px;
        background: #fff;
        border-radius: 14px;
        padding: 16px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

        .tips-title {
            display: flex;
            align-items: center;
            font-size: 15px;
            font-weight: 600;
            color: #333;
            margin-bottom: 12px;

            span {
                margin-left: 6px;
            }
        }

        .tips-list {
            .tips-item {
                display: flex;
                align-items: flex-start;
                font-size: 13px;
                color: #888;
                line-height: 20px;
                margin-bottom: 8px;

                &:last-child {
                    margin-bottom: 0;
                }

                .tips-dot {
                    width: 5px;
                    height: 5px;
                    border-radius: 50%;
                    background: #7EB6F0;
                    margin-top: 7px;
                    margin-right: 8px;
                    flex-shrink: 0;
                }
            }
        }
    }
}

.el-tip {
    padding: 14px;
    line-height: 1.5;
    color: #333;
    font-size: 14px;
}</style>

